<template>
  <div class="dashboard-container">
    <el-row class="dashboard-header flex">
      <el-col class="flex-between">
        <div class="flex">
          <span class="dashboard-company-name font-b">{{ shopDesc.shopName || '--' }}</span>
          <span class="dashboard-company-fans">粉丝数 {{ shopDesc.fCnt || 0 }}</span>
        </div>
        <div class="dashboard-enter-shop">
          <el-button class="font-b" :disabled="!shopDesc.shopId" @click="openShop(shopDesc.shopId)">
            进入店铺 <i class="el-icon-arrow-right font-b"></i>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="dashboard-monitor">
      <el-col class="dashboard-monitor-title dashboard-title">
        店铺监控
      </el-col>
      <el-col class="dashboard-monitor-data flex-around">
        <div class="monitor-item" @click="openRouter('/order/list')">
          <div class="monitor-item-name">待付款</div>
          <div class="monitor-item-num">{{ monitoringData.toBePaymentNum | formatPermil }}</div>
        </div>
        <div class="monitor-item" @click="openRouter('/picker/list')">
          <div class="monitor-item-name">待发货</div>
          <div class="monitor-item-num">{{ monitoringData.toBeDeliveredNum | formatPermil }}</div>
        </div>
        <div class="monitor-item" @click="openRouter('/order/refundlist')">
          <div class="monitor-item-name">待退款售后</div>
          <div class="monitor-item-num">
            {{ monitoringData.toBeRefundAfterSaleNum | formatPermil }}
          </div>
        </div>
        <div class="monitor-item" @click="openRouter('/settlement/list')">
          <div class="monitor-item-name">待结算</div>
          <div class="monitor-item-num">{{ monitoringData.toBeSettledNum | formatPermil }}</div>
        </div>
        <div class="monitor-item" @click="openRouter('/invoice/invoice-list')">
          <div class="monitor-item-name">待开票</div>
          <div class="monitor-item-num">{{ monitoringData.toBeInvoicedNum | formatPermil }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row class="dashboard-search">
      <el-col class="flex">
        <el-date-picker
          class="search-date-picker m-r10"
          type="daterange"
          v-model="daterange"
          size="medium"
          disabled
          range-separator="-"
          :pickerOptions="pickerOptions"
          value-format="timestamp"
          @change="onChangeDatePicker"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button :class="{ active: activeDays === 0 }" @click="selectDate(0)">今天</el-button>
        <el-button :class="{ active: activeDays === 1 }" @click="selectDate(1)">昨日</el-button>
        <el-button :class="{ active: activeDays === 7 }" @click="selectDate(7)">近7天</el-button>
        <el-button :class="{ active: activeDays === 30 }" @click="selectDate(30)">近30天</el-button>
      </el-col>
    </el-row>
    <el-row class="dashboard-shop-data flex">
      <el-col class="shop-data p-20">
        <div class="shop-data-title flex">
          <div class="dashboard-title">店铺数据</div>
          <div class="shop-data-time m-l5">更新时间：{{ shopViews.updateTime || '--' }}</div>
        </div>
        <div class="flex-around">
          <div class="shop-data-pv">
            <div><img src="../../assets/dashboard/pv.png" alt="" /></div>
            <div class="desc">店铺访问次数</div>
            <div class="num">{{ shopViews.pv | formatPermil }}</div>
          </div>
          <div class="shop-data-uv">
            <div><img src="../../assets/dashboard/uv.png" alt="" /></div>
            <div class="desc">店铺访客数</div>
            <div class="num">{{ shopViews.uv | formatPermil }}</div>
          </div>
        </div>
      </el-col>
      <el-col class="shop-hot">
        <div class="shop-hot-title dashboard-title">热门商品点击排行</div>
        <el-table :data="tableData" size="mini" empty-text="暂无热门商品" class="shop-hot-table">
          <el-table-column prop="productInfo" :show-overflow-tooltip="true" label="商品名">
            <template slot-scope="scope">
              <a
                v-if="scope.row.status === '出售中'"
                class="hot-selling-name"
                @click="openGoods(scope.row.itemId)"
              >
                {{ scope.row.productInfo }}
              </a>
              <span v-else>{{ scope.row.productInfo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pv" label="点击次数" width="130"> </el-table-column>
          <el-table-column prop="status" label="状态" width="130">
            <template slot-scope="scope">
              <span :class="{ isSelling: scope.row.status === '出售中' }">
                {{ scope.row.status }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="dashboard-trad-data m-t10">
      <el-col class="dashboard-title">交易数据</el-col>
      <el-col class="dashboard-charts flex-around" v-if="isShowChart">
        <charts :data="orderNumData" />
        <charts :data="payOrderNumData" />
        <charts :data="orderWeightData" />
        <charts :data="orderAmountData" />
      </el-col>
      <div v-else class="noData">暂无数据</div>
    </el-row>
  </div>
</template>

<script>
import charts from './charts'
import splitList from './computed'
import dateFormat from '@/common/utils/date'
import { mapGetters } from 'vuex'
import { ZM_ROOT } from '@/common/constants/'
import open from '@/common/utils/open'
export default {
  name: 'Dashboard',
  components: { charts },
  computed: {
    ...mapGetters(['currentShop'])
  },
  data() {
    return {
      daterange: [],
      activeDays: 30,
      isShowChart: false,
      shopDesc: {}, //店铺信息
      monitoringData: {}, //店铺监控
      shopViews: {}, //店铺数据
      orderNumData: {}, //下单数
      payOrderNumData: {}, //支付订单数
      orderWeightData: {}, //下单重量
      orderAmountData: {}, //下单金额
      tableData: [],
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime()
          let three = 30 * 24 * 3600 * 1000
          let threeMonths = curDate - three
          return time.getTime() > Date.now() || time.getTime() <= threeMonths
        }
      }
    }
  },
  methods: {
    async getShopData() {
      const result = await this.$post('datareport.shop.getShopDataQuery', {
        ShopDataQueryRequest: {
          shopId: this.currentShop.id,
          beginDate: dateFormat(this.daterange[0], 'yyyy-MM-dd'),
          endDate: dateFormat(this.daterange[1], 'yyyy-MM-dd')
        }
      })
      if (result.success) {
        this.monitoringData = result.data[0].monitoringData
        this.shopDesc = result.data[0].shopData.subscription
        this.shopViews = result.data[0].shopData.views
        this.tableData = result.data[0].shopData.hotItem
      }
    },
    async getChartsData() {
      const result = await this.$post('datareport.shop.getShopTradeDataQuery', {
        ShopDataQueryRequest: {
          shopId: this.currentShop.id,
          beginDate: dateFormat(this.daterange[0], 'yyyy-MM-dd'),
          endDate: dateFormat(this.daterange[1], 'yyyy-MM-dd')
        }
      })
      if (result.success) {
        this.isShowChart = true
        const { orderNum, payOrderNum, orderWeight, orderAmount } = splitList(
          result.data[0].shopDetail
        )
        const {
          orderCnt = 0,
          payCnt = 0,
          totalWeight = 0,
          actualTotalFee = 0
        } = result.data[0].shopTrade
        this.orderNumData = { title: '下单数', total: orderCnt, list: orderNum }
        this.payOrderNumData = { title: '支付订单数', total: payCnt, list: payOrderNum }
        this.orderWeightData = {
          title: '下单重量(吨)',
          total: parseFloat(totalWeight.toFixed(4)),
          list: orderWeight
        }
        this.orderAmountData = {
          title: '下单金额(元)',
          total: parseFloat(actualTotalFee.toFixed(2)),
          list: orderAmount
        }
      }
    },
    openShop(shopId) {
      window.open(`${ZM_ROOT}/shop/${shopId}`)
    },
    openGoods(itemId) {
      window.open(`${ZM_ROOT}/goods/${itemId}`)
    },
    openRouter(path) {
      open(path)
    },
    onChangeDatePicker(val) {
      this.activeDays = ''
      this.daterange = val
      this.getShopData()
      this.getChartsData()
    },
    getLastThirtyDays() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      return [dateFormat(start, 'yyyy-MM-dd'), dateFormat(end, 'yyyy-MM-dd')]
    },
    selectDate(val) {
      this.activeDays = val
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * val)
      val === 1 ? end.setTime(end.getTime() - 3600 * 1000 * 24 * val) : ''
      this.daterange = [start, end]
      this.getShopData()
      this.getChartsData()
    }
  },
  created() {
    this.selectDate(this.activeDays)
  }
}
</script>
<style scoped lang="scss">
$red: #cd974c;
$border-color: #f0f0f0;
$black-color: #333333;
$gray-color: #999999;
$background-color: #f8f8f8;
/deep/ .el-table td,
/deep/ .el-table th {
  border: none;
}
/deep/ .el-table th {
  background-color: $background-color;
}
/deep/ .el-table::before {
  height: 0;
}
/deep/ .el-table th > .cell {
  line-height: 18px;
  font-size: 13px;
}
.flex {
  display: flex;
  align-self: center;
}
.flex-between {
  display: flex;
  align-self: center;
  justify-content: space-between;
}
.flex-around {
  display: flex;
  align-self: center;
  justify-content: space-around;
}
.font-b {
  font-weight: 600;
}
.dashboard-title {
  font-weight: 600;
  font-size: 16px;
  color: $black-color;
}
.dashboard-container {
  .dashboard-header {
    height: 60px;
    padding: 0 20px;
    border: 1px solid $border-color;
    background-color: $background-color;
    .dashboard-company-name {
      font-size: 20px;
      line-height: 26px;
      color: $black-color;
    }
    .dashboard-company-fans {
      padding: 2px 6px;
      margin: 2px 6px;
      font-size: 16px;
      border-radius: 1px;
      color: $red;
      background-color: #fdf6f6;
      border: 1px solid #f7d6d8;
    }
    .dashboard-enter-shop {
      .el-button {
        padding: 8px 12px;
        color: $red;
      }
    }
  }
  .dashboard-monitor {
    margin-top: 10px;
    border: 1px solid $border-color;
    .dashboard-monitor-title {
      padding: 20px;
    }
    .dashboard-monitor-data {
      padding: 5px 0 20px 0;
      .monitor-item {
        width: 80px;
        cursor: pointer;
        text-align: center;
      }
      .monitor-item-name {
        @extend .font-b;
        color: $gray-color;
        font-size: 14px;
      }
      .monitor-item-num {
        @extend .font-b;
        margin-top: 14px;
        margin-bottom: 10px;
        font-size: 20px;
        color: $black-color;
      }
    }
  }
  .dashboard-search {
    margin-top: 28px;
    .el-range-editor--medium.el-input__inner {
      height: 32px;
    }
    /deep/ .el-range-editor--medium .el-range-separator {
      line-height: 24px;
    }
    .el-button {
      padding: 8px 20px;
    }
    .el-button + .el-button {
      margin-left: 8px;
    }
    .active {
      color: $red;
      border-color: $red;
    }
  }
  .dashboard-shop-data {
    margin-top: 10px;
    .shop-data {
      width: 40%;
      border: 1px solid $border-color;
      .shop-data-title {
        height: 16px;
        line-height: 16px;
      }
      .shop-data-time {
        font-size: 12px;
        color: $gray-color;
      }
      .shop-data-pv {
        position: relative;
        &:after {
          position: absolute;
          content: '';
          width: 1px; // 边框的宽度
          height: 93px;
          right: 0; //距离 view 标签的距离
          top: 30px;
          background-color: #edeff2; //  颜色
        }
      }
      .shop-data-pv,
      .shop-data-uv {
        width: 50%;
        text-align: center;
        .desc {
          margin: 10px 0;
          font-size: 14px;
          color: $gray-color;
        }
        .num {
          @extend .font-b;
          font-size: 20px;
          color: $black-color;
        }
        img {
          margin: 30px 0 6px 0;
          width: 44px;
          height: 44px;
        }
      }
    }
    .shop-hot {
      margin-left: 1%;
      width: 59%;
      height: 210px;
      padding: 14px;
      border: 1px solid $border-color;
      .shop-hot-title {
        padding: 6px 10px 18px 10px;
      }
      .shop-hot-table {
        font-size: 14px;
        color: $black-color;
        /deep/ .el-table__body-wrapper {
          height: 120px;
          padding-top: 8px;
        }
        .hot-selling-name {
          color: $black-color;
          &:hover {
            color: $red;
          }
        }
        .isSelling {
          color: #92cf54;
        }
      }
    }
  }
  .dashboard-trad-data {
    height: 305px;
    padding: 20px;
    border: 1px solid $border-color;
    .noData {
      text-align: center;
      color: $gray-color;
      line-height: 80px;
    }
  }
}
</style>
